import { ApiCalendarHolidayDate } from "@/types/calendar-holiday.types.ts";
import { ApiTimeOffCalendar, ApiTimeOffLogFullPreview } from "@/types/time-off/time-off.types.ts";
import { endOfDay, format, startOfDay } from "date-fns";

export interface EmployeeTimeOffDayInfo {
  holidays: ApiCalendarHolidayDate[];
  requests: ApiTimeOffLogFullPreview[];
}

export type EmployeeTimeOffDayInfoMap = Map<string, EmployeeTimeOffDayInfo>;

export const getEmployeeTimeOffDayKey = (date: Date) => format(date, "yyyy-MM-dd");

export const buildEmployeeTimeOffDayInfoMap = (
  calendars: Array<ApiTimeOffCalendar | undefined>,
  excludeRequestId?: number
): EmployeeTimeOffDayInfoMap => {
  const map = new Map<string, EmployeeTimeOffDayInfo>();

  for (const calendar of calendars) {
    if (!calendar) continue;

    for (const holiday of calendar.calendar_holidays) {
      const key = getEmployeeTimeOffDayKey(holiday.date);
      const existing = map.get(key) ?? { holidays: [], requests: [] };
      existing.holidays.push(holiday);
      map.set(key, existing);
    }

    for (const request of calendar.requests) {
      if (request.id === excludeRequestId) continue;

      const end = endOfDay(request.time_off_data.date_to);
      const current = startOfDay(request.time_off_data.date_from);

      while (current <= end) {
        const key = getEmployeeTimeOffDayKey(current);
        const existing = map.get(key) ?? { holidays: [], requests: [] };
        existing.requests.push(request);
        map.set(key, existing);
        current.setDate(current.getDate() + 1);
      }
    }
  }

  return map;
};
